import React from 'react';
import PopularAppsCard from '../popular_appscards/popular_apps_cards';
import { useSelector } from 'react-redux';

import BannerCardView from '../popular_appscards/banner_card_view/banner_card_view';
import { captureGAEvent, gaPanelConfig } from '../../shared/helper';
import { clearEvents } from '../../utils/changeHeaderColor';

export default function AdvantageBanner({ data }: { data: any }) {
  // Now, you can directly access `data` inside the component

  // if (data?.apps == null) {
  //   return <div className="flex flex-col md:flex-row justify-center">Something went wrong</div>;
  // }

  const navigateToAppDetails = (slug: string) => {

    sendGAEvent("sras_spotlight_card_click")
    // navigate(`/${slug}`);

    // window.location.href = `/${slug}`;
    const newUrl = `/${slug}`;

    // Push the new URL to the browser history without reloading the page
    window.history.pushState({ path: newUrl }, '', newUrl);
    window.dispatchEvent(new Event('popstate'));
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  const sendGAEvent = (event: string) => {

    gaPanelConfig.CardSection = "spotlight_card";
    gaPanelConfig.AppName = "SquadStack";
    gaPanelConfig.AppStatus = "NA";
    gaPanelConfig.AppSlug = "squadstack";
    gaPanelConfig.AppID = "";
    gaPanelConfig.DeveloperID = "NA";

    captureGAEvent(event, event);
  };
  return (

    <>
      {/* First div - Hide on mobile view */}
      <div className="hidden md:block">
        <div style={{ paddingTop: "54px" }} className="container">
          <div className="flex flex-col md:flex-row justify-center" style={{ gap: "30px" }}>
            {/* First Column */}
            <div className="w-full md:w-3/4 lg:w-3/4">
              <a href="https://www.shiprocket.in/blog/brand-influencer-programmes/" target="_blank" rel="noopener noreferrer">
                <img
                  onClick={(event) => {
                    clearEvents()
                    gaPanelConfig.blog_url = "https://www.shiprocket.in/blog/brand-influencer-programmes/";
                    captureGAEvent("sras_blog_week_card_click", "sras_blog_week_card_click")
                  }}
                  src={'https://s3-ap-south-1.amazonaws.com/kr-shipmultichannel-mum/appstore/app_1724919044_gp4.png'}
                  alt="App World"
                  style={{
                    width: '100%',
                    height: '100%',
                    aspectRatio: 'auto',
                    borderRadius: '25px',
                  }}
                />
              </a>

            </div>

            {/* Second Column */}
            <div className="w-full md:w-1/3 lg:w-1/4 flex justify-center">
              <div
                className="flex flex-col justify-between"
                style={{
                  border: '1px solid #D3D3D3',
                  borderRadius: '25px',
                  opacity: 1,
                  backdropFilter: 'blur(14px)',
                  WebkitBackdropFilter: 'blur(14px)',
                  backgroundImage: `url(${require('../../../../src/assets/gp3.png')})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  width: "100%",
                }}
              >
                <div style={{
                  margin: "20px",
                  paddingTop: "20px",
                  height: '18px',
                  textAlign: 'left',
                  letterSpacing: '4.5px',
                  textTransform: 'uppercase',
                  opacity: 1,
                  fontFamily: "sfprobold",
                  fontSize: "15px",
                  color: "#7A4AFF"
                }}>
                  IN THE SPOTLIGHT
                </div>

                <div className="text-lg md:text-xl  text-black" style={{ margin: "20px", textAlign: "left" }}>
                  <span style={{
                    fontFamily: "sfprobold",
                    letterSpacing: "0px",
                    color: "#301A55",
                    opacity: 1,
                    fontSize: "1.6rem",
                    lineHeight: "normal"
                  }}>
                    Easy-to-use Telecalling solution for customer engagement
                  </span>
                  <div className='container start-0' style={{ marginTop: "40px", paddingRight: "20px" }}>
                    <BannerCardView
                      borderCard={"none"}
                      background={"transparent"}
                      border={"1px solid rgb(226, 226, 226)"}
                      padding={"0px"}
                      borderRadius='15px'
                      overallRating={0}
                      reviewsCount={0}
                      downloadCount='100k'
                      imageUrl={'https://app.shiprocket.in/seller/assets/images/one-impression/logo_squad.png'}
                      title={'SquadStack'}
                      subtitle={'squadstack'}
                      backgroundColor="transparent"
                      titleColor="red"
                      reviewColor="black"
                      appDescription={''}
                      subtitleColor='#7E8B9E'
                      onClick={() => navigateToAppDetails('squadstack')}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      {/* Second div - Show on mobile view */}
      <div className="block md:hidden m-5">
        {/* Content of the second div */}
        <div style={{ paddingTop: "14px" }} className="container">
          <div className="flex flex-col md:flex-col justify-center" style={{ gap: "30px" }}>
            {/* First Column */}
            <div className="w-full md:w-1/3 lg:w-3/4" style={{}}>
              <a href="https://www.shiprocket.in/blog/brand-influencer-programmes/" target="_blank" rel="noopener noreferrer">
                <img
                  src={'https://s3-ap-south-1.amazonaws.com/kr-shipmultichannel-mum/appstore/app_1724919044_gp4.png'}
                  alt="App World"
                  style={{
                    width: '100%',
                    height: '100%',
                    aspectRatio: 'auto',
                    borderRadius: '25px',
                  }}
                />
              </a>
            </div>

            {/* Second Column */}
            <div className="container w-full md:w-1/3 lg:w-1/4 flex justify-center">
              <div
                className="flex flex-col justify-between"
                style={{
                  border: '1px solid #D3D3D3',
                  borderRadius: '25px',
                  opacity: 1,
                  backdropFilter: 'blur(14px)',
                  WebkitBackdropFilter: 'blur(14px)',
                  backgroundImage: `url(${require('../../../../src/assets/gp3.png')})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  width: "100%",
                }}
              >
                <div style={{
                  margin: "20px",
                  paddingTop: "20px",
                  height: '18px',
                  textAlign: 'left',
                  letterSpacing: '4.5px',
                  textTransform: 'uppercase',
                  opacity: 1,
                  color: "#7A4AFF"
                }}>
                  IN THE SPOTLIGHT
                </div>

                <div className="text-lg md:text-xl  text-black" style={{ margin: "20px", paddingBottom: "20px", textAlign: "left" }}>
                  <span style={{
                    fontFamily: "sfprobold",
                    letterSpacing: "0px",
                    color: "#301A55",
                    opacity: 1,
                    fontSize: "1.6rem",
                    lineHeight: "normal"
                  }}>
                    Easy-to-use Telecalling solution for customer engagement
                  </span>
                  <div className='container start-0' style={{ marginTop: "20px", paddingRight: "20px" }}>
                    <BannerCardView
                      borderCard={"none"}
                      background={"transparent"}
                      border={"1px solid rgb(226, 226, 226)"}
                      padding={"0px"}
                      borderRadius='15px'
                      overallRating={0}
                      reviewsCount={0}
                      downloadCount='100k'
                      imageUrl={'https://app.shiprocket.in/seller/assets/images/one-impression/logo_squad.png'}
                      title={'SquadStack'}
                      subtitle={'squadstack_1013'}
                      backgroundColor="transparent"
                      titleColor="red"
                      reviewColor="black"
                      appDescription={''}
                      subtitleColor='#7E8B9E'
                      onClick={() => navigateToAppDetails('squadstack_1013')}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>

  );
}


